const getters = {
  fluidsList: state => state.fluidsList,
  refrigerantsList: state => state.refrigerantsList
};

export default getters;
